import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { observabilityApi, type LogEntry } from '../../api/observability';

export function LogExplorerPage() {
  const [logs, setLogs] = useState<LogEntry[]>([]);
  const [level, setLevel] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    void observabilityApi.logs(level || undefined).then(setLogs).catch((e) => setError(String(e)));
  }, [level]);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/observability" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Operations Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Log Explorer</h1>
      <select className="mt-3 rounded border px-2 py-1 text-sm dark:border-slate-600 dark:bg-slate-900" value={level} onChange={(e) => setLevel(e.target.value)}>
        <option value="">All levels</option>
        <option value="debug">Debug</option>
        <option value="info">Info</option>
        <option value="warn">Warn</option>
        <option value="error">Error</option>
      </select>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-4 divide-y rounded-lg border font-mono text-xs dark:border-slate-700">
        {logs.map((l) => (
          <li key={l.id} className="px-4 py-2">
            <span className="text-slate-500">{new Date(l.timestamp).toISOString()}</span>
            <span className={`ml-2 uppercase ${l.level === 'error' ? 'text-red-600' : l.level === 'warn' ? 'text-yellow-600' : ''}`}>{l.level}</span>
            <span className="ml-2 text-slate-400">{l.service}</span>
            <span className="ml-2">{l.message}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
